import styles from "../../../styles/module/news/news_home.module.css";
import SubTitle from "../others/title/SubTitle";
import Loading from "../others/Loading";
import { imagemURL } from "../../../services/variables";
import { usePostsCard } from "../../../hooks/usePosts";

export default function News() {
  const { data, isError, isLoading } = usePostsCard();

  if (isLoading) return <Loading />;
  if (isError) return <p>Nenhuma noticia encontrada.</p>;

  const newsDestaque = data[0];
  const otherNews = data.slice(1);

  return (
    <div>
      <SubTitle subTitle="Últimas notícias" border={true} />
      <div className={styles.news_container}>
        <div className={styles.section_destaque}>
          <a
            href={`/noticia/${newsDestaque.slug}`}
            target="_self"
            rel="noopener noreferrer"
            className={styles.card_destaque}
            key={newsDestaque.id}
          >
            <div className={styles.imagem_container_destaque}>
              {newsDestaque.featuredImage?.node?.sourceUrl &&
              !newsDestaque.oldImage ? (
                <img
                  alt={
                    newsDestaque.featuredImage.node.altText ||
                    newsDestaque.title
                  }
                  src={newsDestaque.featuredImage.node.sourceUrl}
                  className={styles.imagem_destaque}
                  loading="lazy"
                />
              ) : (
                <img
                  alt={newsDestaque.title}
                  src={imagemURL + newsDestaque.oldImage}
                  className={styles.imagem_destaque}
                  loading="lazy"
                />
              )}
            </div>

            <div className={styles.content_destaque}>
              <h2 className={styles.titulo_destaque}>{newsDestaque.title}</h2>
              <p dangerouslySetInnerHTML={{ __html: newsDestaque.excerpt }} />

              <p className={styles.featuredDate}>
                {new Date(newsDestaque.date).toLocaleDateString("pt-BR", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}
              </p>

              <div className={styles.infos_destaque}>
                <span className={styles.categoria_destaque}>
                  #
                  {newsDestaque.categories?.nodes?.[0]?.name || "Sem categoria"}
                </span>

                <div className={styles.views_destaque}>
                  <span>{newsDestaque.views}</span>
                  <img
                    width={24}
                    height={24}
                    alt="views"
                    src="/icons/views.svg"
                  />
                </div>
              </div>
            </div>
          </a>
        </div>

        <div className={styles.section_aside}>
          {otherNews.slice(0, 4).map((news) => (
            <a
              href={`/noticia/${news.slug}`}
              target="_self"
              rel="noopener noreferrer"
              className={styles.card_aside}
              key={news.id}
            >
              <div className={styles.imagem_aside_container}>
                {news.featuredImage?.node?.sourceUrl && !news.oldImage ? (
                  <img
                    alt={news.featuredImage.node.altText || news.title}
                    src={news.featuredImage.node.sourceUrl}
                    className={styles.imagem_aside}
                    loading="lazy"
                  />
                ) : (
                  <img
                    alt={news.title}
                    src={imagemURL + news.oldImage}
                    className={styles.imagem_aside}
                    loading="lazy"
                  />
                )}
              </div>

              <div className={styles.conteudo_aside}>
                <h3 className={styles.titulo_aside}>{news.title}</h3>
                <p className={styles.data_aside}>
                  {new Date(news.date).toLocaleDateString("pt-BR", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  })}
                </p>

                <div className={styles.infos_aside}>
                  <span className={styles.categoria_aside}>
                    #{news.categories?.nodes?.[0]?.name || "Sem categoria"}
                  </span>

                  <div className={styles.views_aside}>
                    <span>{news.views}</span>
                    <img
                      width={20}
                      height={20}
                      alt="views"
                      src="/icons/views.svg"
                    />
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
